var morph = {
  init: function () {
    this.wowo();
    this.toggler();
    this.appHeight();
    this.lenis();
    this.sticky();
    this.select();
    this.gallery();
    this.slider();
    this.links();
    this.getStickyTop();
    this.swup();
    this.isHomeOrProduct();
  },
  wowo: function () {
    var wTop = $(window).scrollTop(),
      wHeight = $(window).height(),
      wBottom = wTop + wHeight;
    $(".wowo:not(.animated)").each(function () {
      var me = $(this),
        meTop = me.offset().top,
        meHeight = me.innerHeight(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");
      }
    });
  },
  nav: function () {
    if (navigator.userAgent.match(/Trident\/7\./)) {
      document.body.addEventListener &&
        document.body.addEventListener("mousewheel", function () {
          event.preventDefault();
          var wd = event.wheelDelta;
          var csp = window.pageYOffset;
          window.scrollTo(0, csp - wd);
        });
    }
    var sh = $(window).scrollTop();
    if (sh > $(".navbar").height() && $(".navbar").hasClass("is-stuck")) {
      $(".navbar,.navbar-button").removeClass("is-stuck");
    } else if (sh <= $(".navbar").height() && !$(".navbar").hasClass("is-stuck")) {
      $(".navbar,.navbar-button").addClass("is-stuck");
    }
  },
  toggler: function () {

    $('body').on('click', '.nav button.btn', function (e) {
      if ($(window).width() < 768) {
        e.preventDefault();

        let me = $(this);
        if (!me.hasClass('active')) {
          me.addClass('active');
          me.siblings('ul').slideDown(300);
        } else {
          me.removeClass('active');
          me.siblings('ul').slideUp(300);
        }
      }
    })

    $(document).on("click", (e) => {
      if (!$(e.target).closest('.header-row .nav').length && $('.nav button.btn').hasClass('active')) {
        $('.nav button.btn').removeClass('active').siblings('ul').stop().slideUp(300);
      }
    })

  },

  appHeight: function () {
    const doc = document.documentElement;
    let height = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    $('body').attr("style", "--height:" + height + "px");
    doc.style.setProperty('--vh', (jQuery(window).innerHeight() * .01) + 'px');
  },

  lenis: function () {
    const lenis = new Lenis({
      duration: 0.6,
    });

    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf);
  },

  slider: function () {
    function addNbspAfterBrSegments() {
      $('.text p').each(function () {
        const $container = $(this);
        const html = $container.html();
        const segments = html.split(/(<br\s*\/?>)/i);

        const processedSegments = segments.map(segment => {
          if (/<br\s*\/?>/i.test(segment)) {
            return segment;
          }

          const text = $(`<div>${segment}</div>`).text().trim();
          if (!text) return segment;

          const words = text.split(/\s+/).filter(word => word);
          if (words.length < 2) return segment;

          const lastWord = words[words.length - 1];
          const prevWord = words[words.length - 2];
          const regex = new RegExp(
            `(${$.escapeSelector(prevWord)})\\s+(${$.escapeSelector(lastWord)})`,
            'i'
          );

          return segment.replace(regex, `$1\u00A0$2`);
        });

        $container.html(processedSegments.join(''));
      });
    }

    addNbspAfterBrSegments();



    if ($('.banner-slider').length > 0) {
      // if ($('.banner-slider').hasClass('slick-initialized')) {
      //   $('.banner-slider.slick-initialized')[0].slick('refresh');
      // } else {
      //   const slider = $('.banner-slider').slick({
      //     dots: false,
      //     infinite: true,
      //     speed: 500,
      //     slidesToShow: 1,
      //     slidesToScroll: 1,
      //     autoplay: true,
      //     autoplaySpeed: 5000,
      //     arrows: false,
      //     fade: true,
      //   });
      // }

      let mySwiper;
      const $sliderContainer = $('.swiper-container.banner-slider');
      if ($sliderContainer.length) {
        const slideCount = $sliderContainer.find('.swiper-slide').length;

        mySwiper = new Swiper($sliderContainer[0], {
          autoplay: true,
          grabCursor: true,
          effect: 'fade',
          speed: 800,
          loop: true,
        });

        if (slideCount <= 1) {
          mySwiper.destroy();
          return;
        }
      }

      global_el_slider = mySwiper;
    }

  },

  sticky: function () {
    const stickyScroll = () => {
      if (!$('.nav ul li>a').hasClass('text-white')) {
        return;
      }
      let wTop = $(window).scrollTop(),
        wHeight = $(window).height(),
        navPadding = $('.nav').outerHeight() - $('.nav').height();

      let bannerHeight = $('.block-banner').outerHeight();

      if ($(window).width() >= 768) {
        if (wHeight < bannerHeight) {
          const offset = bannerHeight - wHeight + navPadding;
          if (wTop > offset) {
            $('.nav ul li>a').addClass("color-change");
          } else {
            $('.nav ul li>a').removeClass("color-change");
          }
        } else {
          if (wTop > navPadding) {
            $('.nav ul li>a').addClass("color-change");
          } else {
            $('.nav ul li>a').removeClass("color-change");
          }
        }


        if (bannerHeight && wTop > bannerHeight) {
          $('.logo-white,.cart .text-white').addClass("color-change");
        } else {
          $('.logo-white,.cart .text-white').removeClass("color-change");
        }
      } else {
        if (bannerHeight && wTop > bannerHeight) {
          $('.logo-white,.cart .text-white,.nav .text-white').addClass("color-change");
        } else {
          $('.logo-white,.cart .text-white,.nav .text-white').removeClass("color-change");
        }
      }
    }
    stickyScroll();
    $(window).on("scroll", function () {
      stickyScroll();
    })
    $(window).on("resize", function () {
      stickyScroll();
    })
  },

  select: function () {
    $('body').on('click', 'ul li>.option', function (e) {
      e.preventDefault();

      const me = $(this);
      const parent = $(this).parent();
      if (!me.hasClass('active')) {
        parent.siblings('').find('.value').stop().slideUp(300);
        me.addClass('active').siblings('.value').slideDown(300).parent().siblings('').find('.option').removeClass('active');
      } else {
        me.removeClass('active').siblings('.value').stop().slideUp(300);
      }
    })

    $(document).on("click", (e) => {
      if (!$(e.target).closest('.block-gallery-and-text .right .text ul').length && $('.text ul li>.option').hasClass('active')) {
        $('.text ul li>.option').removeClass('active').siblings('.value').stop().slideUp(300);
      }
    })
  },

  gallery: function () {
    let gallery = $('.block-gallery-and-text .left .swiper-container');

    if (gallery.length > 0) {

      let mySwiper = new Swiper('.swiper-container', {
        slidesPerView: "auto",
        freeMode: true,
        spaceBetween: 4,
        grabCursor: true,
      });

      // const swiper = $('.swiper-container');
      // if (swiper.length > 0) {
      // matchMedia check
      const mediaQuery = window.matchMedia('(max-width: 768px)');
      const handleMediaChange = function (e) {
        if (e.matches) {
          morph.wowo();
        }
      };

      handleMediaChange(mediaQuery);

      mediaQuery.addListener(handleMediaChange);
      // }

      global_el_swiper = mySwiper;
    }
  },

  cart: function () {
    // $('body').on('click', 'header .cart>.btn', function (e) {
    //   e.preventDefault();
    //   e.stopPropagation();
    //   if (!$('cart-drawer .drawer').hasClass('active')) {
    //     $('html,body').attr('data-lenis-prevent', 'true');
    //   } else {
    //     $('html,body').removeAttr('data-lenis-prevent');
    //   }
    // })

    // $('body').on('click', '.text .product-form .product-form__buttons>button', function (e) {
    //   $('html,body').attr('data-lenis-prevent', 'true');
    // })

    // $('body').on('click', '.drawer .drawer__close', function (e) {
    //   $('html,body').removeAttr('data-lenis-prevent');
    // })

    // $('body').on("click", '.drawer .cart-drawer__overlay', function (e) {
    //   e.stopPropagation();
    //   $('html,body').removeAttr('data-lenis-prevent');
    // })

  },

  isHomePage: function () {
    if (!$('body').hasClass('global-white')) {
      return;
    }

    const home_el = $('main .is-home-page');
    if (home_el.length > 0) {
      $('.nav .btn,.cart .btn').removeClass('text-black').addClass('text-white');
      $('a.logo').removeClass('logo-black').addClass('logo-white');
    } else {
      $('.nav .btn,.cart .btn').addClass('text-black').removeClass('text-white');
      $('a.logo').addClass('logo-black').removeClass('logo-white');
    }
  },

  isHomeOrProduct: function () {
    // const home_el = $('main .is-home-page'),
    //   product_el = $('main .is-product-page'),
    //   collection_el = $('main .is-collection-page');
    // if (home_el.length > 0 || product_el.length > 0 || collection_el.length > 0) {
    //   $('footer.footer').removeClass('position-fixed');
    // } else {
    //   $('footer.footer').addClass('position-fixed');
    // }

    // if (collection_el.length > 0) {
    //   $('footer.footer').addClass('position-fixed-not-mobile');
    // } else {
    //   $('footer.footer').removeClass('position-fixed-not-mobile');
    // }
    const mianHeight = $('main').outerHeight();
    const wHeight = $(window).height();

    if (mianHeight <= wHeight) {
      $('footer.footer').addClass('position-fixed');
    } else {
      $('footer.footer').removeClass('position-fixed');
    }
  },

  links: function () {

    $('body').on('click', '.nav ul li>a', function (e) {
      $(this).addClass('active').parent().siblings('li').find('a').removeClass('active');
      $('.nav ul li>a').not(this).removeClass('active');
      $('footer .links ul li a').removeClass('active');
    })

    $('body').on('click', 'footer .links ul li a', function (e) {
      $(this).addClass('active').parents('li').siblings('li').find('a').removeClass('active');
      $('footer .links ul li a').not(this).removeClass('active');
      $('.nav ul li>a').removeClass('active');
    })

    $('body').on('click', '.header-row .logo', function (e) {
      $('footer .links ul li a').removeClass('active');
      $('.nav ul li>a').removeClass('active');
    })

  },

  getStickyTop: function () {
    if ($(window).width() >= 768) {
      let wHeight = $(window).height();
      let textHeight = $('.block-gallery-and-text .right .text').outerHeight();

      const _height = (wHeight - textHeight) / 2;
      if (_height > 0) {
        $('.block-gallery-and-text .right .text').attr('style', `--text-sticky-top: ${_height}px;`);
      }
    }
  },

  swup: function () {
    const swup = new Swup({
      animateHistoryBrowsing: false,
      linkSelector: 'a:not([target="_blank"]):not([href^="mailto:"]):not([href^="tel:"])',
      animationSelector: '[class*="transition-"]',
      animationScope: 'html',
      cache: true,
      containers: ['#MainContent'],
      hooks: {},
      ignoreVisit: (url, { el } = {}) => el?.closest('[data-no-swup]'),

      linkToSelf: 'scroll',
      native: false,
      plugins: [],
      resolveUrl: (url) => url,
      requestHeaders: {
        'X-Requested-With': 'swup',
        'Accept': 'text/html, application/xhtml+xml'
      },
      skipPopStateHandling: (event) => event.state?.source !== 'swup',
      timeout: 0
    });

    swup.on('clickLink', function () {

    });
    swup.on('willReplaceContent', () => {

    })
    swup.on('contentReplaced', function () {
      jQuery('html,body').stop().animate({ scrollTop: 0 }, 0);
      if ($('.nav ul li>a').hasClass("color-change")) {
        $('.logo-white,.cart .text-white,.nav .text-white').removeClass("color-change");
      }

      const existingSlider = global_el_slider;
      if (existingSlider) {
        global_el_slider = null;
        existingSlider.destroy();
      }

      const existingSwiper = global_el_swiper;
      if (existingSwiper) {
        global_el_swiper = null;
        existingSwiper.destroy();
      }

      morph.wowo();
      morph.gallery();
      morph.slider();
      morph.getStickyTop();

      morph.isHomePage();
      morph.isHomeOrProduct();
    });
  },
};


var $ = jQuery.noConflict();
let global_el_slider = null,
  global_el_swiper = null;
$(document).ready(function () {
  morph.init();


  const url = window.location.href;
  // const hash = url.split("#")[1];
  const cart_url = 'https://cbfa8d-2.myshopify.com/#cart';

  if (url == cart_url) {
    $('.drawer').addClass('active');
    $('body').addClass('overflow-hidden');
    $('html,body').attr('data-lenis-prevent', 'true');
  }


  // $('.mask').on('animationend', function (e) {

  //   if ($(e.target).is('.mask')) {
  //     e.stopPropagation();
  //     console.log('end');
  //     // $('.mask').fadeOut(400);
  //     $('.mask').hide();
  //   }
  // });
});


$(window).on("scroll", function () {
  morph.wowo();
})


$(window).on("resize", function () {
  morph.appHeight();
  morph.getStickyTop();
  morph.isHomeOrProduct();

  if ($(window).width() >= 768) {
    if ($('.nav button.btn').hasClass('active')) {
      $('.nav button.btn').removeClass('active');
    }
    if ($('.nav ul').attr('style') != undefined) {
      $('.nav ul').removeAttr('style');
    }
  }
})





